module.exports = __webpack_public_path__ + "static/media/Schiratti1928-tagged.ea9ef040.jpg";